
import { computed, defineComponent, Ref, ref } from 'vue'
import { IdfButton, IdfRadio, IdfTextIcon } from '@invivodf/ui-kit'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import {
  DiscountablesMode,
  useMetaDiscountDiscountables,
} from '../../composables/meta-discount/useMetaDiscountDiscountables'
import CUploadedMetaDiscountsAssociations from './CUploadedMetaDiscountAssociations.vue'
import CMetaDiscountsAssociationsModal from './CMetaDiscountsAssociationsModal.vue'
import CDiscountModal, { ModalCommands } from '../CDiscountModal.vue'

export default defineComponent({
  name: 'CUploadMetaDiscountsAssociations',
  components: {
    IdfTextIcon,
    IdfButton,
    IdfRadio,
    CUploadedMetaDiscountsAssociations,
    CDiscountModal,
    CMetaDiscountsAssociationsModal,
  },
  props: {
    message: {
      type: String,
      default: null,
    },
  },
  setup() {
    const i18n = useI18nForVue2()
    const { discountables, setIsExcludedAssociations, isFormUpdate, isExcludedAssociationsForm } =
      useMetaDiscountDiscountables()

    const uploadAssociationsModal = ref<ModalCommands>()
    const showModal = () => {
      return uploadAssociationsModal.value!.show()
    }
    const hideModal = () => uploadAssociationsModal.value!.hide()

    const onValidate = ({ count, file }: { count: number; file: File }) => {
      discountables.file.value = file
      discountables.count.value = count
      hideModal()
    }

    const options = [
      {
        label: `${i18n.t('ctx.discount.form.radio-discountables-included').toString()}`,
        value: DiscountablesMode.INCLUDED,
      },
      {
        label: `${i18n.t('ctx.discount.form.radio-discountables-excluded').toString()}`,
        value: DiscountablesMode.EXCLUDED,
      },
    ]

    const checkedValue: Ref<string | undefined> = computed({
      get: (): string | undefined => {
        return isExcludedAssociationsForm() ? DiscountablesMode.EXCLUDED : DiscountablesMode.INCLUDED
      },
      set: (newValue: string | undefined): void => {
        setIsExcludedAssociations(newValue === DiscountablesMode.EXCLUDED)
      },
    })

    const isFormUpdateMode = computed(() => isFormUpdate())

    const ctaAddDiscountablesLabel = computed(() =>
      discountables.count.value
        ? `${i18n.t('ctx.discount.form.update-discountables').toString()}`
        : `${i18n.t('ctx.discount.form.add-discountables').toString()}`,
    )

    return {
      discountables,
      uploadAssociationsModal,
      showModal,
      hideModal,
      onValidate,
      options,
      checkedValue,
      isFormUpdateMode,
      ctaAddDiscountablesLabel,
    }
  },
})
